import React from 'react'
import { Button } from '@mui/material'
import useFavurTranslation from 'hooks/useFavurTranslation'
import { Container } from './styles'
import type { ModalActionButtonsProps } from './types'

const ModalActionButtons: React.FC<ModalActionButtonsProps> = ({ onClick, onClose }) => {
  const { t } = useFavurTranslation()

  return (
    <Container data-testid="comment-modal-action-buttons">
      <Button variant="text" color="inherit" onClick={onClose}>
        {t('common.cancel')}
      </Button>
      <Button variant="contained" data-testid="comment-modal-send-button" onClick={onClick}>
        {t('button.send')}
      </Button>
    </Container>
  )
}

export default ModalActionButtons
